<template>
	<b-modal centered id="irrigation-duration-alert" hide-footer @hide="onHide">
		<p class="my-4">{{ $t(`global.irrigation_exceeded` )}}</p>

		<div class="d-flex justify-content-end" style="gap: 0.5rem;">
			<b-button size="md" @click="cancel">{{ $t(`global.cancel`) }}</b-button>
			<template v-if="activeField">
				<b-button size="md" variant="primary" @click="editSavedField">{{ $t(`global.edit_field`) }}</b-button>
			</template>
			<template v-else>
				<b-button size="md" variant="secondary" @click="redrawField">{{ $t(`global.redraw_field`) }}</b-button>
				<b-button size="md" variant="primary" @click="changePipeSize">{{ $t(`global.change_pipe_size`) }}</b-button>
			</template>
		</div>
	</b-modal>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'IrrigationTimeExceededModal',

  data () {
    return {
      // Set when an action button handles the dismissal, so the generic
      // @hide handler (header X / Esc / backdrop) doesn't also run cleanup.
      actionTaken: false
    };
  },

  computed: {
    ...mapState(['activeField'])
  },

  methods: {
    // Fires for ALL close triggers (header X, Esc, backdrop, Cancel button,
    // programmatic). If an explicit Edit/Change action was chosen we skip
    // cleanup (that flow keeps the polygon); otherwise — including the header
    // X, Esc, backdrop, and Cancel — clean up a draft field's leftover polygon.
    onHide () {
      if (!this.actionTaken && !this.activeField) {
        this.$emit('cancelDraft');
      }
      this.actionTaken = false;
    },

    cancel () {
      // Cleanup is handled by onHide; just close.
      this.$bvModal.hide('irrigation-duration-alert');
    },

    editSavedField () {
      this.actionTaken = true;
      this.$bvModal.hide('irrigation-duration-alert');
      this.$bvModal.show('edit-' + this.activeField.key);
    },

    changePipeSize () {
      this.actionTaken = true;
      this.$bvModal.hide('irrigation-duration-alert');
      this.$emit('retryWithNewPipeSize');
    },

    redrawField () {
      this.actionTaken = true;
      this.$bvModal.hide('irrigation-duration-alert');
      this.$emit('redrawField');
    }
  }
}
</script>
